import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { EnvironmentService } from './EnvironmentService';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  supportPhone = signal<string>('060-608 97 15');

  constructor(private http: HttpClient, private env: EnvironmentService) {}

  sendFeedback(feedback: Feedback): Promise<any> {
    return lastValueFrom(
      this.http.post<any>(`${this.env.apiUrl}/feedback`, {
        feedback: feedback,
      }),
    );
  }
}

export interface Feedback {
  name?: string;
  email?: string;
  problem_description: string;
  problem_area: string;
  expected_outcome: string;
  actual_outcome: string;
}
